export const GA_CATEGORY = {
  SHARE_INTERVIEW: 'share_interview',
  SHARE_INTERVIEW_ONE_PAGE: 'share_interview_one_page',
  SHARE_INTERVIEW_3_STEPS: 'share_interview_3_steps',
  SHARE_INTERVIEW_TYPE_FORM: 'share_interview_type_form',
  SHARE_TIME_SALARY: 'share_time_salary',
  SHARE_TIME_SALARY_ONE_PAGE: 'share_time_salary_one_page',
  SHARE_TIME_SALARY_TYPE_FORM: 'share_time_salary_type_form',
  SHARE_TIME_SALARY_TYPE_FORM_HIDE_PROGRESS_BAR:
    'share_time_salary_type_form_hide_progress_bar',
  SHARE_WORK: 'share_work',
  FORM_TIME: 'form_time',
  SEARCH_EXPERIENCE: 'search_experience',
  LOGIN: 'login',
  HEADER: 'header',
  TEST_NEW_FEATURE: 'test_new_feature',
  JOB_TITLE_PAGE: 'job_title_page',
  COMPANY_PAGE: 'company_page',
  READ_MORE: 'read_more',
};

export const GA_ACTION = {
  START_WRITING: 'start_writing',
  UPLOAD_SUCCESS: 'upload_success',
  UPLOAD_FAIL: 'upload_fail',
  CLICK_LATEST: 'click_latest',
  CLICK_POPULAR: 'click_popular',
  TOGGLE_ON: 'toggle_on',
  TOGGLE_OFF: 'toggle_off',
  SEARCH_BY: 'search_by',
  FETCH_MORE: 'fetch_more',
  CLICK_TIME_AND_SALARY: 'click_time_and_salary',
  CLICK_EXPERIENCE_SEARCH: 'click_experience_search',
  CLICK_LABOR_RIGHTS: 'click_labor_rights',
  CLICK_SHARE_DATA: 'click_share_data',
  CLICK_PRIVATE_MESSAGE_BUTTON: 'click_private_message_button',
  SEARCH_COMPANY: 'search_company',
  SEARCH_JOB_TITLE: 'search_job_title',
  CLICK_READ_MORE_EXPERIENCE: 'click_read_more_experience',
};
